import PageModel from '@/models/pageModel'

export class MedicalServiceTypes extends PageModel {
    static moduleName = 'medicalServiceTypes';
    static moduleEntityName = 'medicalServiceType';
    static moduleUrl = 'medical-service-types';
    static distanceFactorsName = 'distance-factors';
    static listTitle = 'Справочник типов консультаций';
    static apiPrefix = 'medical-service-types';
}